module.exports = __webpack_public_path__ + "img/Gifcard_pacchetto_A.2b943475.jpg";